import { render, staticRenderFns } from "./PriceSelector.vue?vue&type=template&id=77236ac1&scoped=true"
import script from "./PriceSelector.vue?vue&type=script&lang=js"
export * from "./PriceSelector.vue?vue&type=script&lang=js"
import style0 from "./PriceSelector.vue?vue&type=style&index=0&id=77236ac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77236ac1",
  null
  
)

export default component.exports